import React from "react";
import PropTypes from "prop-types";
import { useAuth0 } from "@auth0/auth0-react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import SwipeableViews from "react-swipeable-views";
import { Grid, useMediaQuery, Tabs, Tab, List, ListItem, ListItemText, Collapse } from "@material-ui/core";
import { ExpandLess, ExpandMore } from '@material-ui/icons';
import TalentInfo from "./views/talentInfoView";
import TalentEducationView from "./views/talentEducationView";
import TalentExperience from "./views/talentExperienceView";
import TalentSkills from "./views/talentSkillsView";
import AssessmentView from './views/assessmentView';
import CoursesView from './views/coursesView';
import NavBar from "../components/navbar";
import TalentIdentity from "../components/talentIdentity";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && children}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  noScroll: {
    height: '100%',
    overflowY: 'hidden'
  },
  scroll: {
    overflowY: 'scroll'
  },
  list: {
    color: "white",
  },
  listItem: {
    paddingLeft: "50px",
    color: "white"
  },
  verNav: {
    height: "100vh",
    backgroundColor: "#153BAB",
  },
  verScrollNav: {
    height: "100%",
    backgroundColor: "#153BAB",
  },
  horNav: {
    backgroundColor: "#153BAB",
  },
  views: {
    marginTop: "30px",
    marginLeft: "30px",
    height: "100%",
  }
}));

const TalentProfile = () => {
  const matches = useMediaQuery("(max-width:599px)");
  const midMatches = useMediaQuery("(max-width:959px)");
  const theme = useTheme();
  const [value, setValue] = React.useState(0);
  const { user } = useAuth0();

  const classes = useStyles();
  const [open, setOpen] = React.useState(true);
  const [assessment, setAssessment] = React.useState(false)
  const [courses, setCourses] = React.useState(false)
  const [profile, setProfile] = React.useState(true)

  const assessmentClick = () => {
    setOpen(false);
    setProfile(false);
    setAssessment(true);
    setCourses(false);
  }

  const coursesClick = () => {
    setOpen(false);
    setProfile(false);
    setCourses(true);
    setAssessment(false);
  }

  const handleClick = () => {
    setOpen(!open);
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
    setProfile(true);
    setCourses(false);
    setAssessment(false);
  };

  const handleChangeIndex = (index) => {
    setValue(index);
  };

  return (
      <div className={midMatches? classes.scroll: classes.noScroll}>
        {/* <div className={classes.scroll}> */}
        <NavBar type="main" />
        <Grid container direction="row" justify="center" alignItems="stretch">
          <Grid item xs={12} sm={4} lg={3}>
            <Grid
            container
            direction="column"
            justify="flex-start"
            alignItems="center"
            className={matches? classes.horNav : (midMatches? classes.verScrollNav : classes.verNav)}>
              <TalentIdentity user={user} />
              <Grid 
              container 
              direction="column" 
              alignItems="center">
                <List component="nav"
                aria-labelledby="nested-list"
                className={classes.list}>
                  <ListItem
                    className={classes.listItem}
                    button
                    onClick={handleClick}>
                    <ListItemText primary="Profile" />
                    {open ? <ExpandLess /> : <ExpandMore />}
                  </ListItem>
                  <Collapse in={open} timeout="auto" unmountOnExit>
                    <Tabs
                    orientation="vertical"
                    variant="scrollable"
                    value={value}
                    onChange={handleChange}
                    aria-label="tabs">
                      <Tab label="General Info" {...a11yProps(0)} />
                      <Tab label="Experience" {...a11yProps(1)} />
                      <Tab label="Education" {...a11yProps(2)} />
                      <Tab label="Skills" {...a11yProps(3)} />
                    </Tabs>
                  </Collapse>
                  <ListItem button className={classes.listItem}  onClick={assessmentClick}>
                    <ListItemText primary="Assessment" />
                  </ListItem>
                  <ListItem button className={classes.listItem} onClick={coursesClick}>
                    <ListItemText primary="Courses" />
                  </ListItem>
                </List>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={8} lg={9} className={classes.noScroll}>
            { assessment && <AssessmentView /> }
            { courses && <CoursesView /> }
            { profile && <SwipeableViews
              axis={theme.direction === "rtl" ? "x-reverse" : "x"}
              index={value}
              onChangeIndex={handleChangeIndex}
              className={classes.views} >
                <TabPanel value={value} index={0} dir={theme.direction}>
                  <TalentInfo />
                </TabPanel>
                <TabPanel value={value} index={1} dir={theme.direction}>
                  <TalentExperience id={user && user.sub} />
                </TabPanel>
                <TabPanel value={value} index={2} dir={theme.direction}>
                  <TalentEducationView id={user && user.sub} />
                </TabPanel>
                <TabPanel value={value} index={3} dir={theme.direction}>
                  <TalentSkills id={user && user.sub} />
                </TabPanel>
              </SwipeableViews> 
            }
          </Grid>
        </Grid>
      </div>
  );
};

export default TalentProfile;
